import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { TMSCustomer } from 'types/Load';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export async function setCustomerIsTest(
  customerID: number,
  isTest: boolean
): Promise<Result<TMSCustomer, ApiError>> {
  try {
    const response = await axios.patch<TMSCustomer>(
      `/customers/${customerID}/is-test`,
      { isTest }
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'setCustomerIsTest' });
    if (!isAxiosError(error)) {
      return err({ message: 'Unable to update customer.' });
    }
    const data = error.response?.data as { message?: string; code?: string };
    return err({
      message: data?.message ?? 'Unable to update customer.',
      status: error.response?.status,
      response: data,
    });
  }
}
